import { PageHero } from "@/src/components/PageHero";
import { Commitments } from "./(sections)/Commitments";
import { Newsletter } from "@/src/pages/home/(sections)/newsletter/Newsletter";

export function SustainabilityPage() {
    return (
        <>
            <PageHero
                image="https://images.unsplash.com/photo-1536657464919-892534f60d6e?auto=format&fit=crop&q=80&w=2000"
                label="How we operate"
                title="Sustainability"
            />
            <Commitments />
            <Newsletter />
        </>
    );
}
